import React from "react";
import { Button, Tooltip } from "antd";
import {
  MenuOutlined,
  QuestionCircleOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import OrgSwitcher from "./OrgSwitcher";
import UserProfileMenu from "./UserProfileMenu";
import ThemePicker from "./ThemePicker";
import { canManageMembers } from "../utils/rbac";

export default function AppHeader({ onLogout, isMobile, onOpenNav }) {
  const navigate = useNavigate();

  return (
    <div className="app-header">
      <div className="app-header-left">
        {isMobile ? (
          <Button
            type="text"
            className="app-header-icon-btn app-header-nav-trigger"
            icon={<MenuOutlined />}
            onClick={onOpenNav}
            aria-label="Open navigation menu"
          />
        ) : null}
        <OrgSwitcher />
      </div>
      <div className="app-header-right">
        <ThemePicker variant="header" />
        <Tooltip title="Help & support">
          <Button
            type="text"
            className="app-header-icon-btn"
            icon={<QuestionCircleOutlined />}
            onClick={() => navigate("/app/settings?tab=support")}
            aria-label="Help and support"
          />
        </Tooltip>
        {canManageMembers() ? (
          <Tooltip title="Add team member">
            <Button
              type="text"
              className="app-header-icon-btn"
              icon={<UserAddOutlined />}
              onClick={() => navigate("/app/settings?tab=team")}
              aria-label="Add team member"
            />
          </Tooltip>
        ) : null}
        <UserProfileMenu onLogout={onLogout} />
      </div>
    </div>
  );
}
